import React from 'react'

const renderRow = () => {
  return (
    <tr className='border-b bg-transparent border-gray-700'>
      <td className='p-4'>
        <div className='h-4 w-32 bg-gray-500 rounded-full animate-pulse'></div>
      </td>
      <td className='p-4'>
        <div className='h-4 w-24 bg-gray-500 rounded-full animate-pulse'></div>{' '}
      </td>
      <td className='p-4'>
        <div className='h-4 w-24 bg-gray-500 rounded-full animate-pulse'></div>{' '}
      </td>
      <td className='p-4'>
        <div className='h-4 w-24 bg-gray-500 rounded-full animate-pulse'></div>{' '}
      </td>
      <td className='p-4'>
        <div className='h-4 w-24 bg-gray-500 rounded-full animate-pulse'></div>{' '}
      </td>
      <td className='p-4'>
        <div className='h-4 w-24 bg-gray-500 rounded-full animate-pulse'></div>{' '}
      </td>
    </tr>
  )
}
export const OrdersTableSkeleton = () => {
  return (
    <table className='relative w-full text-sm text-left text-gray-400'>
      <thead className='text-xs uppercase bg-gray-700 text-gray-300'>
        <tr>
          <th scope='col' className='py-3 px-6'>
            Transaction ID
          </th>
          <th scope='col' className='py-3 px-6'>
            Type
          </th>

          <th scope='col' className='py-3 px-6'>
            Amount
          </th>
          <th scope='col' className='py-3 px-6'>
            Rate
          </th>
          <th scope='col' className='py-3 px-6'>
            Status
          </th>
          <th scope='col' className='py-3 px-6'></th>
        </tr>
      </thead>
      <tbody>
        {Array(5)
          .fill(0)
          .map((_) => renderRow())}
      </tbody>
    </table>
  )
}
